import { css } from '@emotion/css';
import { colors } from 'constants/theme';

const depositPageStyles = {
    tabList: css`
        display: flex;
        border-bottom: 1px solid #aec2ee;
        color: ${colors.primary};
        justify-content: center;
        padding-bottom: 20px;
    `,
    tabItem: css`
        padding: 12px 16px;
        cursor: pointer;
        border-radius: 10px;
        box-shadow: 0 2px 2px rgba(0,0,0, .2);
        margin-right: 10px;
        &:hover, &.active {
            background: ${colors.lottery};
            color: ${colors.white};
        }
    `,
    bankGroup: css`
        padding: 16px 0;
        /* border-bottom: 1px solid ${colors.borderTable}; */
    `,
    titleBankGroup: css`
        margin-bottom: 8px;
        font-weight: 400;
        color: ${colors.primary};
        span {
            color: ${colors.primary};
            font-weight: 500;
        }
    `,
    bankList: css`
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        min-height: 57px;
    `,
    bankItem: css`
        padding: 2px;
        /* background: #201b4c; */
        border-radius: 8px;
        box-shadow: 0 2px 2px rgba(0,0,0, .2);
        cursor: pointer;
        border: 2px solid transparent;
        &:hover,
        &.active {
            border:2px solid #B80005;
        }
    `,
    bankItemInner: css`
        background: ${colors.white};
        border-radius: 6px;
        padding: 2px 3px;
        border: 2px solid transparent;
        position: relative;
        p {
            color: ${colors.black};
            text-align: center;
            font-weight: bold;
        }
    `,
    bankIcon: css`
        width: 78px;
        height: 38px;
        object-fit: contain;
    `,
    iconBankSelect: css`
        position: absolute;
        left: -6px;
        top: -6px;
        width: 20px;
    `,
    iframeDeposit: css`
        height: 700px;
        margin-top: 16px;
        iframe {
            border: none;
            width: 100%;
            height: 100%;
        }
    `,
};
export default depositPageStyles;
